(function () {
  'use strict';

  angular.module('clientDashboardApp.admin.users.locations.userLocationsEditor',
    [
      'clientDashboardApp.admin.users.userManagerService',
      'clientDashboardApp.admin.locations.locationsManagerService'
    ]).controller("UserLocationsEditorCtrl", UserLocationsEditorCtrl);

  UserLocationsEditorCtrl.$inject = ['$q', '$scope', '$state', '$stateParams','$log', '$location', 'userManagerService','locationsManagerService', 'locationService', 'pagingService', 'accountsService','updateService','stringService'];
  function UserLocationsEditorCtrl($q, $scope, $state, $stateParams, $log, $location, userManagerService, locationsManagerService, locationService, pagingService, accountsService, updateService, stringService) {
    var vm = this;

    vm.userId = $stateParams.userId;

    var resetPage = function () {
      vm.submitted = false;
      vm.loading = true;
      vm.locationsToAdd = [];
      vm.locationsToRemove = [];
      vm.selected = [];
      vm.totalSelected = 0;
    };

    var firstSearch = true;

    vm.state = {
      updating: false
    }

    vm.mode = "edit";

    vm.accountConfig = {
      required : true,
      accountId : null,
      showAccountSelection: false,
      editPage: true
    }

    vm.pageStrings = stringService.adminStrings();

    vm.updateConfig = {
      entityId : null,
      pageOneResult : true
    }

    vm.locationSelectionOptions = [
      {name:"Display All Locations", value:0},
      {name:"Only User Locations", value:1},
      {name:"Only Available Locations", value:2}
    ]

    vm.locationSelection = vm.locationSelectionOptions[0];

    vm.showUserLocations = true;
    vm.showNonUserLocations = true;

    $scope.$watch('vm.pagedData.currentPageNum',function(newVal,oldVal){
      if(newVal !== oldVal){
        updateTotalSelected();
        vm.toggleAllCheckbox = allLocationsSelected();
      }
    });

    var updateTotalSelected = function(){
      vm.totalSelected = _.where(vm.pagedData.allResults(),{selected : true}).length;
    }

    var handleSearchResults = function handleSearchResults(results) {

      function sortedByName(locations) {
        return _.sortBy(locations, (x) => x.businessName.toUpperCase());
      }
      function removeDuplicates(locations) {
        var seen = {}
        return _.filter(locations, (x) => {
          if (seen[x.id]) return false;
          else {
            seen[x.id] = true;
            return true;
          }
        })
      }
      /** allAccountLocations doesn't include locations that user has in other accounts **/
      var allAccountLocations = results.allLocations.data.locations;
      var currentLocations = sortedByName(results.currentLocations.locations);
      var allLocations = sortedByName(removeDuplicates(currentLocations.concat(allAccountLocations)));
      var availableLocations = sortedByName(_.filter(allLocations, (x) => !_.findWhere(currentLocations, {id: x.id})));

      if(currentLocations.length && firstSearch){
        vm.locationSelection = vm.locationSelectionOptions[1];
      }

      _.each(allLocations,function(item){
        item.currentLocation = _.where(currentLocations,{id:item.id}).length > 0;
        item.selected = item.currentLocation;
      });

      _.each(currentLocations,function(item){
        _.extend(item,{currentLocations:true,selected:true});
      });

      vm.availablePaged = pagingService.createPagingData(availableLocations, 10);
      vm.groupPaged = pagingService.createPagingData(currentLocations, 10);
      vm.allPaged = pagingService.createPagingData(allLocations, 10);

      vm.pagedData = vm.allPaged;
      updateTotalSelected();

      vm.allLocations = allLocations;
      vm.currentLocations = currentLocations;
      vm.availableLocations = availableLocations;

      vm.totalAvailableLocations = availableLocations.length;
      vm.accountConfig.accountId = vm.accountId;
      vm.filterLocationsByDisplayOption();
      vm.toggleAllCheckbox = allLocationsSelected();
      vm.loading = false;
      firstSearch = false;
    };

    vm.filterLocationsByDisplayOption = function(){
      if (vm.locationSelection.value==0) {
        vm.pagedData = vm.allPaged;
      } else if (vm.locationSelection.value==1) {
        vm.pagedData = vm.groupPaged;
      } else if (vm.locationSelection.value==2) {
        vm.pagedData = vm.availablePaged;
      }
      else{
        vm.pagedData = pagingService.createPagingData({},10);
      }
      updateTotalSelected();
      vm.toggleAllCheckbox = allLocationsSelected();
    }

    vm.toggleAllLocations = function () {

      var checked = vm.toggleAllCheckbox;
      var locationsObject = {};

      locationsObject = vm.pagedData.allResults();
      _.each(_.where(locationsObject,{selected : !checked}), function (location) {
        vm.processCheckboxEvent(location.id,true);
        location.selected = checked;
      });
      vm.toggleAllCheckbox = allLocationsSelected();

    };

    function allLocationsSelected() {
      if(vm.pagedData && vm.pagedData.allResults()){
        if(!vm.pagedData.allResults().length){
          return false;
        }
        return vm.pagedData.allResults().length === vm.totalSelected;
      }
      return false;
    };

    vm.isCurrentLocation = function(locationId){
      return _.where(vm.currentLocations,{id: locationId}).length;
    }

    var getCheckboxValue = function(locationId){
      return _.findWhere(vm.pagedData.currentResults(),{id:locationId}).selected;
    }

    vm.processCheckboxEvent = function (locationId, batch) {
      var checked = batch ? vm.toggleAllCheckbox : getCheckboxValue(locationId);
      if (checked) {
        if(!vm.isCurrentLocation(locationId)){
          vm.locationsToAdd.push(locationId);
        }
        else{
          vm.locationsToRemove = _.without(vm.locationsToRemove, locationId);
        }
        vm.totalSelected++;
      }
      else {
        if(vm.isCurrentLocation(locationId)){
          vm.locationsToRemove.push(locationId);
        }
        else{
          vm.locationsToAdd = _.without(vm.locationsToAdd,locationId);
        }
        vm.totalSelected--;
      }
      if(!batch){
        vm.toggleAllCheckbox = allLocationsSelected();
      }
    };

    vm.cancel = function(){
      $location.path("admin/v2/users");
    }

    vm.toBeAdded = function (locationId) {
      return _.contains(vm.locationsToAdd, locationId);
    };

    vm.toBeRemoved = function (locationId) {
      return _.contains(vm.locationsToRemove, locationId);
    };

    vm.hasChanges = function () {
      return vm.locationsToRemove.length + vm.locationsToAdd.length > 0;
    };

    vm.formatAddress = function (address) {
      return locationService.formatAddress(address)
    };

    var handleSuccessfulUpdate = function handleSearchResults() {
      var actions = [];
      if(vm.locationsToAdd.length){
        actions.push({action:"create",count:vm.locationsToAdd.length});
      }
      if(vm.locationsToRemove.length){
        actions.push({action:"delete",count:vm.locationsToRemove.length});
      }
      var updateInfo = {
        status: "Active",
        type: "userLocation",
        title: "User Location",
        destinationRole: "edit",
        notificationType: "total",
        actions: actions,
        id: null,
        totalUpdates: vm.locationsToAdd.length + vm.locationsToRemove.length
      }
      updateService.registerSuccessfulUpdate(updateInfo);
      $state.reload();
    };

    var handleUpdateFailure = function handleUpdateFailure() {
      vm.state.updating = false;
      vm.errorMsg = 'An error occurred while updating this group.';
    };

    vm.updateGroup = function updateGroup() {
      vm.state.updating = true;
      if (!vm.hasChanges) {
        $log.info('No changes to process.');
        return;
      }
      vm.submitted = true;
      vm.errorMsg = null;

      var updateRequests ={};
      if(vm.locationsToRemove.length > 0) {
        //Remove Locations
        updateRequests.remove = userManagerService.removeLocationsFromUser(vm.userId, vm.locationsToRemove);
      }

      if(vm.locationsToAdd.length > 0) {
        //Add locations
        updateRequests.add = userManagerService.addLocationsToUser(vm.userId, vm.locationsToAdd);
      }
      $q.all(updateRequests).then(handleSuccessfulUpdate,handleUpdateFailure);
    };

    vm.locationQuery = null;

    vm.refreshAll = function () {
      var promises = {};
      userManagerService.getUser(vm.userId).then(function(resp){
        vm.accountId = resp.data.accountId;
        vm.username = resp.data.username;
        promises.currentLocations = userManagerService.listUserLocations(vm.userId, vm.locationQuery);
        promises.allLocations = locationsManagerService.listLocations(vm.accountId, vm.locationQuery, true, true);
        promises.accountList = accountsService.listAccounts();
        $q.all(promises).then(handleSearchResults);
      });
    };

    resetPage();
    vm.refreshAll();

  }
})();
